import React from "react";
import Select from '@material-ui/core/Select';
import {ButtonsGroup, PaperStyled} from "../../../index.styles";
import {baasEmploymentTypeFull, IEKYCDetails} from "../../../../../../../types/entities/users";
import {Field, FieldsWrapper} from "../index.styles";
import dateFormat from "../../../../../../../utils/date-format";
import concatAddress from "../../../../../../../utils/concat-address";
import deconcatAddress from "../../../../../../../utils/deconcat-address";
import {Input, InputLabel, MenuItem} from "@material-ui/core";
import Button from "components/control/button/button";
import {EButtonType} from "../../control/button/button.types";
import TextField from "@material-ui/core/TextField";

type TEditPersonalDetailParam = {
  setMode: (mode: string) => void;
  data: IEKYCDetails;
  setUpdatedData: (updatedData: IEKYCDetails) => void;
};
const EditPersonalInfo = ({
  setMode,
  data,
  setUpdatedData,
}: TEditPersonalDetailParam) => {
  const [updatedName, setUpdatedName] = React.useState<string>(data?.name || '');
  const [updatedDateOfBirth, setUpdatedDateOfBirth] = React.useState<string>(data?.dateOfBirth ? dateFormat(data.dateOfBirth) : '' );
  const [updatedPlaceOfBirth, setUpdatedPlaceOfBirth] = React.useState<string>(data?.placeOfBirth || '');
  const [updatedMaritalStatus, setUpdatedMaritalStatus] = React.useState<string>(data?.maritalStatus || '');
  const [updatedGender, setUpdatedGender] = React.useState<string>(data?.gender || '');
  const [updatedNationality, setUpdatedNationality] = React.useState<string>(data?.nationality || 'INDONESIA')
  const [updatedAddress, setUpdatedAddress] = React.useState<string>(data?.idAddress ? concatAddress(data.idAddress) : '');
  const [updatedResidentialAddress, setUpdatedResidentialAddress] = React.useState<string>(data?.idAddress ? concatAddress(data.idAddress) : '');
  const [updatedEmploymentType, setUpdatedEmploymentType] = React.useState<string>(data?.employmentType || '');

  // Format date of birth to YYYY-MM-DD
  const checkDateOfBirthFormat = (date: string) => {
    // Check if it's on DD/MM/YYYY format then convert to YYYY-MM-DD
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (dateRegex.test(date)) {
      const dateArray = date.split('/');
      return `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
    }
    return date;
  }

  const handleConfirm = () => {
    const updatedData: IEKYCDetails = {
      ...data,
      name: updatedName,
      dateOfBirth: checkDateOfBirthFormat(updatedDateOfBirth),
      placeOfBirth: updatedPlaceOfBirth,
      maritalStatus: updatedMaritalStatus,
      gender: updatedGender,
      idAddress: {
        ...data?.idAddress,
        ...deconcatAddress(updatedAddress),
      },
      residentialAddress: {
        ...data?.residentialAddress,
        ...deconcatAddress(updatedResidentialAddress),
      },
      nationality: updatedNationality,
      employmentType: updatedEmploymentType,
    }
    setUpdatedData(updatedData)
  }

  const handleReset = () => {
    const updatedData: IEKYCDetails = {
      ...data,
    }
    setUpdatedData(updatedData)
  }

  return (
    <PaperStyled>
      <FieldsWrapper>
        <Field>
          <InputLabel className="title" htmlFor="name">Name:</InputLabel>
          <Input className="value" name="name" id="name" type="text" defaultValue={updatedName} onChange={(event) => {
            setUpdatedName(event.target.value)
          }} />
        </Field>
        <Field>
          <InputLabel className="title" htmlFor="placeOfBirth">Place of Birth:</InputLabel>
          <Input className="value" name="placeOfBirth" id="placeOfBirth" defaultValue={updatedPlaceOfBirth} onChange={event => setUpdatedPlaceOfBirth(event.target.value)}/>
        </Field>
        <Field>
          <InputLabel className="title">{'Date of birth'}:</InputLabel>
          <TextField
            className="value"
            name='dateOfBirth'
            id='dateOfBirth'
            defaultValue={ updatedDateOfBirth }
            helperText="Date of Birth is in the format: DD/MM/YYYY"
            onChange={event => {
              setUpdatedDateOfBirth(event.target.value)
            }}
          />
        </Field>
        <Field>
            <InputLabel className="title" id={'marital-status'}>Marital Status:</InputLabel>
            <Select
              labelId={'marital-status'}
              className={'value'}
              variant="standard"
              value={updatedMaritalStatus}
              onChange={(e) => setUpdatedMaritalStatus(e.target.value as string)}
            >
              <MenuItem value={'MARRIED'}>Married</MenuItem>
              <MenuItem value={'SINGLE'}>Single</MenuItem>
            </Select>
        </Field>
        <Field>
          <InputLabel className="title" id={'gender'}>Gender':</InputLabel>
          <Select
            labelId={'gender'}
            className={'value'}
            variant="standard"
            value={updatedGender}
            onChange={event => setUpdatedGender(event.target.value as string)}
          >
            <MenuItem value={'MALE'}>Male</MenuItem>
            <MenuItem value={'FEMALE'}>Female</MenuItem>
          </Select>
        </Field>
        <Field>
          <InputLabel className="title">Nationality:</InputLabel>
          <Input className="value" name='nationality' id='nationality' defaultValue={ updatedNationality || 'Indonesia' } onChange={event => setUpdatedNationality(event.target.value)}/>
        </Field>
        <Field>
          <InputLabel className="title">{'Address'}:</InputLabel>
          <TextField
            className="value"
            name='idAddress'
            id='idAddress'
            defaultValue={updatedResidentialAddress}
            helperText="Address format: (address, sub-district, district, city, province, postal code, and country) separated with comma (,)"
            onChange={event => setUpdatedAddress(event.target.value)}/>
        </Field>
        <Field>
          <InputLabel className="title">{'Residential Address'}:</InputLabel>
          <TextField
            className="value"
            name='idAddress'
            id='idAddress'
            defaultValue={updatedResidentialAddress}
            helperText="Address format: (address, sub-district, district, city, province, postal code, and country) separated with comma (,)"
            onChange={event => setUpdatedResidentialAddress(event.target.value)}/>
        </Field>
        <Field>
          <InputLabel className="title" id={'employment'}>Employment Type:</InputLabel>
          <Select
            labelId={'employment'}
            className={'value'}
            variant="standard"
            value={updatedEmploymentType}
            onChange={event => setUpdatedEmploymentType(event.target.value as string)}
          >
            {
              Object.entries(baasEmploymentTypeFull).map(([key, value]) => (
                <MenuItem key={key} value={key}>{value}</MenuItem>
              ))
            }
          </Select>
        </Field>
      </FieldsWrapper>
      <ButtonsGroup>
        <Button
          styleType={EButtonType.Outline}
          onClick={() => {
            handleReset()
            setMode('view')
          }}
        >
          {'Cancel'}
        </Button>
        <Button
          styleType={EButtonType.Primary}
          onClick={() => {
            handleConfirm()
            setMode('view')
          }}
        >
          {'Submit'}
        </Button>
      </ButtonsGroup>
    </PaperStyled>
  )
}

export default EditPersonalInfo
